class AdpTextLinkController {
  constructor() {
    this.name = 'adpTextLink';
  }
}

export default AdpTextLinkController;



// WEBPACK FOOTER //
// ./src/app/components/adpTextLink/adpTextLink.controller.js